/**
 * <s-phone-input> combines a country dialling code <select> and a local number
 * <input> into one international (E.164) value in a hidden field just before the
 * surrounding form submits, so Shopify saves the phone number correctly.
 */
class SPhoneInput extends HTMLElement {
  connectedCallback() {
    this.form = this.closest('form');
    this.code = this.querySelector('[data-phone-code]');
    this.number = this.querySelector('[data-phone-number]');
    this.output = this.querySelector('[data-phone-output]');
    if (!this.form || !this.code || !this.number || !this.output) return;

    this.handleSubmit = () => {
      const raw = this.number.value.trim();
      if (!raw) {
        this.output.value = '';
        return;
      }
      if (raw.startsWith('+')) {
        this.output.value = '+' + raw.replace(/\D/g, '');
        return;
      }
      const digits = raw.replace(/\D/g, '').replace(/^0+/, '');
      this.output.value = this.code.value + digits;
    };
    this.form.addEventListener('submit', this.handleSubmit);
  }

  disconnectedCallback() {
    if (this.form && this.handleSubmit) this.form.removeEventListener('submit', this.handleSubmit);
  }
}

if (!customElements.get('s-phone-input')) customElements.define('s-phone-input', SPhoneInput);
